import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { frame, text, variants as inputVariants } from '../common/InputAndTextarea.common';

const textInputSlotRecipe = defineSlotRecipe({
  className: 'bitkit-text-input',
  slots: ['field', 'input', 'element'],
  base: {
    field: {
      ...frame,
      alignItems: 'center',
      color: 'input/text/inputValue',
      display: 'flex',
      height: 'var(--input-height)',
      minWidth: 0,
      '&:has(input:focus-visible)': {
        boxShadow: '0 0 0 0.125rem var(--focus-ring-color) inset',
      },
      // BitkitSearchInput opts in purely by rendering <input type="search"> — no prop threading. It
      // gets 12px inline padding on both sides, tightening to 4px on the trailing edge when the clear
      // button is present (data-has-end-element). The higher :has() specificity overrides the size
      // paddingInline; the gap widens to 12 at lg (size variant below).
      '&:has(input[type="search"])': {
        paddingInline: '12',
        '&[data-has-end-element]': {
          paddingInlineEnd: '4',
        },
      },
      _invalid: {
        ...frame._invalid,
        zIndex: 1,
      },
      _disabled: {
        ...frame._disabled,
        boxShadow: 'none',
      },
    },
    input: {
      ...text,
      background: 'transparent',
      borderWidth: 0,
      flex: '1',
      focusVisibleRing: 'none',
      height: '100%',
      lineHeight: 'normal',
      minWidth: 0,
      padding: 0,
      width: '100%',
      '&::-webkit-search-cancel-button': { display: 'none' },
      _invalid: {
        color: 'input/text/error',
      },
      _disabled: {
        ...text._disabled,
        cursor: 'not-allowed',
      },
    },
    element: {
      alignItems: 'center',
      color: 'icon/tertiary',
      display: 'flex',
      flexShrink: '0',
      _disabled: {
        color: 'icon/disabled',
      },
    },
  },
  variants: {
    size: {
      md: {
        field: {
          gap: '8',
          paddingInline: inputVariants.size.md.paddingInline,
          '--input-height': inputVariants.size.md['--input-height'],
        },
        input: {
          textStyle: inputVariants.size.md.textStyle,
        },
      },
      lg: {
        field: {
          gap: '8',
          paddingInline: inputVariants.size.lg.paddingInline,
          '--input-height': inputVariants.size.lg['--input-height'],
          '&:has(input[type="search"])': {
            gap: '12',
          },
        },
        input: {
          textStyle: inputVariants.size.lg.textStyle,
        },
      },
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default textInputSlotRecipe;
